import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-sim-nao-modal",
  templateUrl: "./sim-nao-modal.component.html",
  styleUrls: ["./sim-nao-modal.component.css"],
})
export class SimNaoModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SimNaoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  ngOnInit() {}
}

export interface ConfirmDialogData {
  title: string;
  msg: string;
}
